import { render, staticRenderFns } from "./Teen4.vue?vue&type=template&id=61c35f30&scoped=true&"
import script from "./Teen4.vue?vue&type=script&lang=js&"
export * from "./Teen4.vue?vue&type=script&lang=js&"
import style0 from "./Teen4.vue?vue&type=style&index=0&id=61c35f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c35f30",
  null
  
)

export default component.exports